export const testimonials = [
  {
    name: 'Juan Ramírez',
    role: 'HVAC Service Technician',
    location: 'San Antonio, TX',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/6f710e1e-e234-4bde-a3c4-50d2368899c6.jpg',
    quote:
      'The intake checklist alone changed how I start a call. I used to bounce between the contactor, the board and the thermostat. Now I write down what I know, map the circuit, and only then pick my next check. My notes finally make sense when I hand the job off.',
  },
  {
    name: 'Daniela Ortiz',
    role: 'HVAC Maintenance Professional',
    location: 'Phoenix, AZ',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/4eb3eceb-dede-4852-a296-ee3e9b9ccdb9.jpg',
    quote:
      'I work commercial maintenance and documentation is half the job. The measurement logbook and the expected vs. observed worksheet keep everything in one place. My supervisor noticed the difference in my reports within the first week.',
  },
  {
    name: 'Marcus Bell',
    role: 'HVAC Service Team Leader',
    location: 'Atlanta, GA',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/9ad9d534-a4e3-40c4-98d5-7eb5c4aefb02.jpg',
    quote:
      'I lead a crew of six. Getting everyone to document the same way was always the struggle. We adopted the five-stage pathway and the handoff templates, and now when a second tech picks up a call, he knows exactly what was checked and what is still open.',
  },
  {
    name: 'Ryan Cole',
    role: 'HVAC Diagnostic Technician',
    location: 'Columbus, OH',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/934e330c-9e3a-4fdc-b007-0159a567268b.jpg',
    quote:
      'The control circuit decision trees are the part I use most. Separating confirmed findings from assumptions sounds simple, but having it on paper stopped me from repeating the same measurements. For $27 it’s one of the best tools in my van.',
  },
];
